import fetchRetry from 'fetch-retry';
import { TimeoutError } from './timeout';
export const withRetry = (wrappedFetch, retryOptions, context) => (input, options) => {
    const { minRetryDelay = 100, retries = 0 } = retryOptions || {};
    const customFetch = retryOptions
        ? fetchRetry(wrappedFetch, {
            // eslint-disable-next-line no-restricted-properties
            retryDelay: attempt => Math.pow(2, attempt) * minRetryDelay,
            ...retryOptions,
            retryOn: (attempt, error, response) => {
                if (context.span) {
                    if (attempt === 1) {
                        context.span.setTag('request.retried', true);
                    }
                    if (attempt > 0) {
                        context.span.setTag('request.retries_count', attempt);
                    }
                }
                if (attempt >= retries) {
                    return false;
                }
                if (error !== null || response.status >= 500) {
                    if (error instanceof TimeoutError) {
                        /**
                         * In case of timeout error, we need to recreate abort controller instance so that
                         * each retry can use its own instance of abort controller.
                         */
                        context.abortController = null;
                    }
                    return true;
                }
                if (Array.isArray(retryOptions.retryOn)) {
                    return retryOptions.retryOn.includes(response.status);
                }
                if (typeof retryOptions.retryOn === 'function') {
                    return retryOptions.retryOn(attempt, error, response);
                }
            },
        })
        : wrappedFetch;
    return customFetch(input, options);
};
//# sourceMappingURL=retry.js.map